export const LIST = "AGENT_SETTING_LIST";
export const DETAILS = "AGENT_SETTING_DETAILS";
export const UPDATE = "AGENT_SETTING_UPDATE";
export const STORE = "AGENT_SETTING_STORE";